/* eslint-disable prettier/prettier */
export const motionCol = 'w-full flex flex-col gap-1.5';

export const topRow = 'w-full flex gap-1.5';

export const cardFactory = 'relative bg-[#F9FAFB] w-full h-[9.621rem] rounded-t-[1.25rem] rounded-b-[0.625rem]';

export const cardMedi = 'relative flex items-start justify-center bg-[#D9D8FE] w-full h-[9.621rem] rounded-t-[1.25rem] rounded-b-[0.625rem]';

export const labelFactory =
  'mt-2 mx-2 py-[0.188rem] px-[0.563rem] bg-[#6B7280] rounded-full text-white text-[0.75rem] leading-[1.375rem] text-center font-bold tracking-[-0.019rem]';

export const labelMedi =
  'w-fit mt-2 mx-2 py-[0.188rem] px-[0.563rem] bg-[#423DF9] rounded-full text-white text-[0.938rem] leading-[1.375rem] text-center font-bold tracking-[-0.019rem]';

export const imageWrapFactory = 'absolute bottom-0 right-1/2 translate-x-1/2 w-[6.24rem] h-[6.174rem]';

export const imageWrapMedi = 'absolute bottom-0 right-4 w-[11.181rem] h-[6.891rem]';

export const categoryRow = 'flex gap-1.5';

export const gridCellFactory = 'flex flex-col w-full min-h-[4.68rem] gap-1.5 bg-[#F9FAFB] py-2.5 px-2 rounded-lg';

export const gridCellMedi = 'flex flex-col w-full min-h-[4.68rem] gap-1.5 bg-[#D9D8FE] py-2.5 px-2 rounded-lg';

export const rowInner = 'w-full flex items-start justify-start gap-1.5';

export const checkIcon = 'flex-shrink-0 relative w-[1.041rem] h-[1.041rem]';

export const checkIconImg = 'w-full h-full';

export const cellTypography = 'text-[0.875rem] leading-[140%] tracking-[-0.019rem] whitespace-pre-line';

export const cellTypographyMedi = 'font-bold text-[#111619]';

export const cellTypographyFactory = 'font-medium text-[#6B7280]';

export const highlight = 'text-[#423DF9]';
